// Colonne « Format » de la modale Documents : une feuille couchée pour le
// paysage, debout pour le portrait.
//
// La rotation seule se lit mal : à 18 px, une feuille tournée d'un quart de tour
// ressemble à une feuille droite. Le paysage porte donc aussi une couleur, et le
// portrait reste dans le gris du reste du tableau — c'est le format courant, il
// n'a pas à attirer l'œil. Bleu pastel pour ne pas faire concurrence aux
// couleurs qui, elles, signalent quelque chose (tags, action destructrice).

/** Bleu pastel du paysage, lisible sur le fond blanc des lignes. */
export const LANDSCAPE_FORMAT_COLOR = '#6FA8DC';
/** Gris de texte secondaire d'antd : le portrait reste discret. */
export const PORTRAIT_FORMAT_COLOR = '#8C8C8C';

/** Taille des icônes dans le tableau (vue Liste), au large. */
export const FORMAT_ICON_SIZE = 22;
/**
 * Taille dans l'arbre (vue Dossiers) : ses lignes font 26 px de haut et
 * l'icône doit y tenir sans les agrandir, l'arbre étant virtualisé.
 */
export const COMPACT_FORMAT_ICON_SIZE = 20;

export const documentFormatLabel = (landscape) =>
  landscape ? 'Format paysage' : 'Format portrait';

export const documentFormatIconStyle = (landscape, size = FORMAT_ICON_SIZE) => ({
  transform: landscape ? 'rotate(-90deg)' : 'scaleX(-1)',
  color: landscape ? LANDSCAPE_FORMAT_COLOR : PORTRAIT_FORMAT_COLOR,
  fontSize: size,
});
